<template>
    <div class="tab-menu-wrap">
        <ul class="tab-menu">
            <li class="tab-menu__item active"><router-link to="/kr/mypage/member/updateMember">개인정보수정</router-link></li>
            <li class="tab-menu__item"><router-link to="/kr/mypage/member/outMember">회원탈퇴</router-link></li>
        </ul>
    </div>
    <template v-if="step == 1">
        <div class="emphasis">
            <div class="emphasis--icon">
                <img v-if="$store.state.hospStore.hostNm == '대동맥혈관병원'" src="/resource/icon/emphasis-icon02.svg" class="" alt="">
                <img v-else-if="$store.state.hospStore.hostNm == '뇌혈관병원'" src="/resource/icon/emphasis-icon02-brain.svg" class="" alt="">
                <img v-else-if="$store.state.hospStore.hostNm == '엄마아기병원'" src="/resource/icon/emphasis-icon02-mom.svg" class="" alt="">
                <img v-else-if="$store.state.hospStore.hostNm == '혈액암병원'" src="/resource/icon/emphasis-icon02-blood.svg" class="" alt="">
            </div>
            <h3 class="title02">개인정보 보호를 위해 비밀번호를<br> 다시 한번 입력해 주세요.</h3>
            <input type="password" v-model="myInfo.pass">
            <div class="botton-wrap"><a href="javascript:;" class="main-button c-main" @click="passwordCheck">확인</a></div>
        </div>
    </template>
    <template v-if="step == 2">
        <div class="input-form">
            <ul class="input-form__list">
                <li class="input-form__item">
                    <div class="box">
                        <div class="tit"> 아이디</div>
                        <div class="cont">{{myInfo.id}}</div>
                    </div>
                </li>
                <li class="input-form__item" v-if="myInfo.ptNo">
                    <div class="box">
                        <div class="tit"> 환자등록번호</div>
                        <div class="cont">{{myInfo.ptNo}}</div>
                    </div>
                </li>
                <li class="input-form__item" v-if="$store.getters.getNaverYn != 'Y'">
                    <div class="box">
                        <div class="tit"> 비밀번호</div>
                        <div class="cont">
                            <!-- active -->
                             <label :class="{pw: true, active: confirmPw(myInfo.pass) == 'Y', error: confirmPw(myInfo.pass) == 'N'}">
                                <input type="password" class="input" placeholder="영문 대소문자+숫자+특수문자 8자 이상" v-model="myInfo.pass">
                            </label>
                            <p class="cont__desc">※ 대문자, 소문자, 숫자, 특수문자 조합으로 8자리 이상 입력하시면 자동으로 ‘사용 가능‘으로 바뀝니다.<br>※ 사용가능한 특수문자 범위 : !@#$%^&*</p>
                        </div>
                    </div>
                </li>
                <li class="input-form__item" v-if="$store.getters.getNaverYn != 'Y'">
                    <div class="box">
                        <div class="tit"> 비밀번호 확인</div>
                        <div class="cont">
                            <label :class="{pw: true, active: confirmPw(myInfo.passValid) == 'Y' && myInfo.pass == myInfo.passValid, error: (confirmPw(myInfo.passValid) == 'N' || myInfo.pass != myInfo.passValid) && myInfo.passValid}">
                                <input type="password" class="input" placeholder="영문 대소문자+숫자+특수문자 8자 이상" v-model="myInfo.passValid">
                            </label>
                        </div>
                    </div>
                </li>
                <li class="input-form__item">
                    <div class="box">
                        <div class="tit"> 이름</div>
                        <div class="cont">{{myInfo.name}}</div>
                    </div>
                </li>
                <li class="input-form__item">
                    <div class="box">
                        <div class="tit"> 생년월일</div>
                        <div class="cont">{{myInfo.birth}}</div>
                    </div>
                </li>
                <li class="input-form__item">
                    <div class="box">
                        <div class="tit"> 휴대전화번호</div>
                        <div class="cont">
                            <input type="text" class="input" placeholder="‘_’ 제외하고 입력" v-model="myInfo.hpNo" readonly @click="updatePhone">
                            <a href="javascript:;" class="main-button c-sub" @click="updatePhone">번호변경</a>
                        </div>
                    </div>
                </li>
                <li class="input-form__item">
                    <div class="box">
                        <div class="tit"> 이메일</div>
                        <div class="cont">
                            <label :class="{'pw': true, 'active': confirmEmail(myInfo.email) == 'Y', 'error': confirmEmail(myInfo.email) == 'N', 'dup': confirmEmail(myInfo.email) == 'D'}">
                                <input type="text" class="input" placeholder="ewha123@naver.com" v-model="myInfo.email" v-on:keyup="confirmEmail(myInfo.email)">
                            </label>
                            <!-- <input type="text" :class="{input: true, active: confirmEmail(myInfo.email) == 'Y', error: confirmEmail(myInfo.email) == 'N'}" placeholder="ewha123@naver.com" v-model="myInfo.email"> -->
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <div class="botton-wrap">
            <a href="javascript:;" class="main-button c-main" @click="updateMember">수정</a>
        </div>
    </template>
</template>

<script>
export default {
    data() {
        return {
            myInfo: this.$store.state.myInfoStore,
            step: this.$store.getters.getNaverYn == 'Y' ? 2 : 1,
            pass: '',
            passValid: '',
            sMobileNo: '',
        };
    },
    methods: {
        passwordCheck() {
            if(!this.myInfo.pass){
                alert('비밀번호를 입력해주세요.')
                return
            }

            this.axios({
                url: this.api.mypage.passwordCheck,
                method: 'post',
                params: {pass: this.myInfo.pass}
            })
                .then(res => {
                    if (res.data.result.code === 'OK') {
                        this.step = 2;
                        this.myInfo.pass = ''
                        this.myInfo.passValid = ''
                    } else {
                        alert(res.data.result.message);
                    }
                    if(res.data.result.code === 'E_SERVER'){
                        location.reload()
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        updateMember() {
            // naver 가입 제외
            if(this.$store.getters.getNaverYn != 'Y'){
                if(this.confirmPw(this.myInfo.pass) == 'N'){
                    alert('비밀번호를 확인해주세요.')
                    return
                }
                if(this.myInfo.pass && (this.confirmPw(this.myInfo.passValid) != 'Y' || this.myInfo.pass != this.myInfo.passValid)){
                    alert('비밀번호 확인을 확인해주세요.')
                    return
                }
            }
            if(this.confirmEmail(this.myInfo.email) != 'Y'){
                alert('이메일을 확인해주세요.')
                return
            }

            this.myInfo.creDt = null
            this.axios({
                url: this.api.mypage.myInfoUpdate,
                method: 'post',
                params: this.myInfo
            }).then((response) => {
                this.myInfo.pass = ''
                this.myInfo.passVaild = ''
                if (response.data.result.code === 'OK') {
                    if(this.sMobileNo) this.$store.state.myInfoStore.hpNo = this.sMobileNo
                    alert('회원정보가 수정되었습니다.');
                    this.$router.push('/kr/mypage/mypage');
                } else {
                    alert('수정에 실패하였습니다.');
                    location.reload()
                }
            }).catch((error) => {
                console.log(error);
            });
        },
        confirmPw(pass) {
            if(pass == ''){
                return ''
            }
            const regex = /^[a-zA-Z0-9!@#$%^&*]{8,}$/
            const numChk = pass.search(/[0-9]/g)
            const upperChk = pass.search(/[A-Z]/g)
            const lowerChk = pass.search(/[a-z]/g)
            const speChk = pass.search(/[!@#$%^&*]/g)

            return regex.test(pass) && numChk >= 0 && upperChk >= 0 && lowerChk >= 0 && speChk >= 0 ? 'Y' : 'N'
        },
        confirmEmail(email) {
            if(email == ''){
                return ''
            }
            const regex = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/;
  
            return regex.test(email) ? 'Y' : 'N'
        },
        updatePhone(){
            this.axios.get(this.api.member.encData, {
                params: {
                    hostNm: this.$store.state.hospStore.hostName
                }
            }).then(encResponse => {
                const data = encResponse.data

                this.$store.commit('setNiceType', 'update')
                const url = data.authUrl;
                window.open(url, 'popup', 'width=500, height=550, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=yes, location=no, scrollbar=no');

                // const form = document.createElement("form");
                // form.method = "POST";
                // form.action = 'https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb';
                // form.target = "popup"; // 새 창에서 요청을 보낼 수 있도록 설정

                // // 데이터 파라미터 추가
                // const encodeData = document.createElement("input");
                // encodeData.type = "hidden";
                // encodeData.name = "EncodeData";
                // encodeData.value = data.sEncData;

                // // 데이터 파라미터 추가
                // const m = document.createElement("input");
                // m.type = "hidden";
                // m.name = "m";
                // m.value = "checkplusSerivce";

                // form.appendChild(encodeData);
                // form.appendChild(m);

                // document.body.appendChild(form);
                // form.submit();
                // document.body.removeChild(form);

            })
        },
    },
    mounted() {
        window.addEventListener("message", (event) => {
            try {

                if (event.data && event.data.source === "react-devtools-content-script") {
                    return;
                }

                const receivedData = JSON.parse(event.data); // JSON 파싱
                if (receivedData.data.sMobileNo != '' && receivedData.data.sMobileNo != null) {
                    this.sMobileNo = receivedData.data.sMobileNo
                    this.myInfo.hpNo = this.sMobileNo
                }
            } catch (e) {
                console.error("Invalid JSON data received:", e);
            }
        });
    }
}
</script>

<style scoped></style>